var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25213 8.12663C1.13386 8.12703 1.0179 8.09387 0.917727 8.03099C0.817554 7.96811 0.737278 7.8781 0.686225 7.77141C0.635173 7.66473 0.61544 7.54574 0.629319 7.42829C0.643198 7.31083 0.690119 7.19973 0.764631 7.10788L6.95213 0.732878C6.99855 0.679304 7.06179 0.6431 7.13149 0.630211C7.2012 0.617321 7.27321 0.628511 7.33571 0.661943C7.39822 0.695375 7.4475 0.749063 7.47547 0.814195C7.50343 0.879327 7.50843 0.952033 7.48963 1.02038L6.28963 4.78288C6.25425 4.87758 6.24236 4.97945 6.255 5.07976C6.26764 5.18006 6.30442 5.2758 6.36219 5.35877C6.41996 5.44174 6.49699 5.50945 6.58668 5.5561C6.67637 5.60276 6.77603 5.62696 6.87713 5.62663H11.2521C11.3704 5.62622 11.4864 5.65939 11.5865 5.72227C11.6867 5.78514 11.767 5.87516 11.818 5.98184C11.8691 6.08853 11.8888 6.20751 11.8749 6.32497C11.8611 6.44242 11.8141 6.55353 11.7396 6.64538L5.55213 13.0204C5.50572 13.074 5.44247 13.1102 5.37277 13.123C5.30307 13.1359 5.23105 13.1247 5.16855 13.0913C5.10605 13.0579 5.05677 13.0042 5.0288 12.9391C5.00083 12.8739 4.99583 12.8012 5.01463 12.7329L6.21463 8.97038C6.25002 8.87568 6.2619 8.7738 6.24926 8.6735C6.23662 8.57319 6.19984 8.47745 6.14208 8.39449C6.08431 8.31152 6.00727 8.24381 5.91758 8.19715C5.8279 8.1505 5.72823 8.1263 5.62713 8.12663H1.25213Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/generate.59fed575fd793e5785e56e13ea624b21.svg";
export { ForwardRef as ReactComponent };